import React from 'react';

function ListViewShortcutMenu() {
  return null;
}
export default React.memo(ListViewShortcutMenu);